/* @flow */

import { rem } from 'polished';

import {
  baseColor,
  errorColor,
  warningColor,
  successColor,
} from '@e180/ui/lib/token/color';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { mediumGrey, aaDarkGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';
import { topBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    width: '100%',
    height: topBarHeight,
    paddingBottom: 8,

    backgroundColor: baseColor,
    borderBottom: ['solid', 1, aaDarkGrey],
  },
  'root-withoutBorder': {
    borderBottom: 'none',
  },
  'root-withAction': {},
  headings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    overflow: 'hidden',

    width: '100%',
    padding: [0, 8],

    textAlign: 'center',

    '$root-withAction &': {
      width: '60%',
    },
  },
  heading: {
    overflow: 'hidden',

    width: '100%',
    margin: 0,

    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  'heading-small': {
    overflow: 'hidden',

    width: '100%',

    fontSize: rem(16, baseFontSize),
    fontWeight: 700,
    lineHeight: 19 / 16,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  subtitle: {
    extend: antialiasing,

    overflow: 'hidden',

    width: '100%',
    margin: 0,

    color: mediumGrey,

    fontSize: rem(13, baseFontSize),
    fontStyle: 'italic',
    lineHeight: 15 / 13,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  'subtitle-withError': {
    color: errorColor,
  },
  'subtitle-withWarning': {
    color: warningColor,
  },
  'subtitle-withSuccess': {
    color: successColor,
  },
  ctn: {
    display: 'flex',
    width: ({ hasTitle }) => (hasTitle ? '20%' : 'auto'),
  },
  cancelCtn: {},
  actionCtn: {
    justifyContent: 'flex-end',
  },
  link: {
    display: 'flex',
    alignItems: 'flex-end',

    // DIRTY: rules below increases the touch target
    height: 40,
    marginBottom: -8,
    paddingBottom: 8,
  },
  cancel: {
    minWidth: 80,
    paddingLeft: 10,
  },
  action: {
    minWidth: 0,
    paddingRight: 10,
  },
  label: {
    overflow: 'hidden',

    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
